import React, { Component } from 'react';

class MyNested extends Component {

    componentDidMount(){
        this.someMethod();
    }

    someMethod = () =>{
        window.alert("Hey!")
    }

    render() {
        return (
          <div className="App">
                Somethuing here
          </div>
        );
      }
}

export default MyNested;


// WEBPACK FOOTER //
// /projects/test/staticreact/testeroo/src/containers/MyNested.js